// extracted by mini-css-extract-plugin
module.exports = {"component":"StatusTabs_component__y2Zel","menu":"StatusTabs_menu__1AQ6b","nameWrap":"StatusTabs_nameWrap__2p5eG","name":"StatusTabs_name__2cZxa","count":"StatusTabs_count__1OnSD"};